import { render, staticRenderFns } from "./PackageSelector.vue?vue&type=template&id=7a154e41"
import script from "./PackageSelector.vue?vue&type=script&lang=js"
export * from "./PackageSelector.vue?vue&type=script&lang=js"
import style0 from "./PackageSelector.vue?vue&type=style&index=0&id=7a154e41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports